<template>
  <Navbar :url="URL"/>
  <div class="userArticle">
    <div class="member" v-if="user">
      <i v-if="!URL" class="fas fa-user-friends friends"></i>
      <img v-if="URL" :src="URL" alt="">
      <label for="upload"><i class="fas fa-camera"></i>  Upload Your Photo</label>
      <input id="upload" type="file" @change="filechange">
      <div>
        <div class="displayname">{{ user.displayName }}</div>
        <div>{{ user.email}}</div>
      </div>
    </div>
    <h1>My Articles</h1>
    <div v-if="error">{{ error }}</div>
    <div v-if="posts" class='layout'>
      <Postlist :posts="posts" />
    </div>
    <div v-else>
      <Spinner/>
    </div>
  </div>
</template>

<script>
import getPosts from '../composables/getPosts'
import Navbar from '../components/Navbar'
import Spinner from '../components/Postlist'
import Postlist from '../components/Postlist'
import getUser from '../composables/getUser'
import useStorage from '../composables/useStorage'
import { projectAuth }from '../firebase/config'
import { ref } from 'vue'
export default {
  components: {
    Navbar,
    Postlist,
    Spinner
  },
  setup() {
    const { user } = getUser();
    const file = ref(null);
    const fileError = ref(null);
    const URL = ref(projectAuth.currentUser.photoURL);
    const { posts, error } = getPosts('posts', ['userId', '==', user.value.uid]);
    const { uploadFile, url, filepath, deleteImag } = useStorage();
    const types = ['image/png', 'image/jpg', 'image/jpeg'];
    const filechange = async (e) => {
      let selected = e.target.files[0];
      if(selected && types.includes(selected.type)){
        file.value = selected;
        await uploadFile(file.value);
        await projectAuth.currentUser.updateProfile({ photoURL: url.value});
        URL.value = projectAuth.currentUser.photoURL;
      } else {
        file.value = null;
        fileError.value = 'Please select an image file (png or jpg)'
      }
    }
    return { posts, error, user, filechange, URL, fileError }
  }
}
</script>

<style scoped>
  .userArticle {
    max-width: 1200px;
    margin: 0 auto;
    padding: 10px;
  }
  .layout {
    margin: 0 auto;
    width: 100%;
  }
  .member {
    display: flex;
    align-items: center;
    margin-bottom: 45px;
  }
  .member input {
    display: none;
  }
  .member label {
    color: black;
    font-size: 15px;
  }
  .member label:before {
    display: none;
  }
  .member img {
    width: 64px;
    height: 64px;
    object-position: center center;
    object-fit: cover;
    border-radius: 50%;
  }
  .member>div {
    display: inline-block;
    align-items: center;
    margin-left: 60px;
  }
  .member .friends {
    display: inline-block;
    font-size: 42px;
  }
  .member .displayname {
    font-size: 1.5rem;
  }
</style>